// A right-hand slide-over on the estate tokens — replaces Mantine's Drawer at
// the ported call sites (ADR-0010). Content is mounted only while open, which
// is load-bearing for RunInsights: its two endpoints full-scan the run.
import { X } from 'lucide-react'
import { type ReactNode, useEffect } from 'react'

export function Drawer({ opened, onClose, title, children }: {
  opened: boolean
  onClose: () => void
  title: ReactNode
  children: ReactNode
}) {
  useEffect(() => {
    if (!opened) return
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [opened, onClose])

  if (!opened) return null
  return (
    <div
      className="fixed inset-0 z-40 bg-black/40"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose()
      }}
    >
      <div className="absolute inset-y-0 right-0 flex w-full max-w-3xl flex-col border-l border-border bg-background shadow-2xl">
        <div className="flex items-center justify-between gap-4 border-b border-border px-4 py-3">
          <h2 className="text-base font-semibold text-foreground">{title}</h2>
          <button
            className="rounded p-1 text-muted-foreground hover:bg-muted"
            onClick={onClose}
            aria-label="Close"
          >
            <X size={16} />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4">{children}</div>
      </div>
    </div>
  )
}
